// Fire-and-forget reporting to the wallet-connection log
// (netlify/functions/log-connection.ts), so the admin panel can show every
// account that's actually connected a wallet on the site, and when. Called
// from WalletContext.tsx whenever a session is established — both an
// explicit "Connect wallet" click and a silently-restored previous session
// count, since both mean "this account is here right now."
//
// Deduped client-side to once per account per calendar day (localStorage),
// so a returning visitor with a persisted session doesn't generate a new
// row every single page load — the admin panel wants "who showed up, which
// days", not a raw page-view counter. A failure here must never surface to
// the user or block anything else.

const DEDUP_KEY_PREFIX = "waxcreator-conn-logged-";

function todayStamp(): string {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD, local session's clock
}

export function logConnection(account: string, via: "explicit" | "restored"): void {
  try {
    const key = `${DEDUP_KEY_PREFIX}${account}`;
    const today = todayStamp();
    if (localStorage.getItem(key) === today) return; // already logged today
    localStorage.setItem(key, today);
  } catch {
    /* localStorage unavailable (private mode etc.) — just log every time */
  }

  fetch("/.netlify/functions/log-connection", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ account, via }),
  }).catch(() => {
    /* best-effort only — never let a logging failure affect the user */
  });
}
